const getBarcodeFromBase64 = (base64) => {
    return `data:image/png;base64,${base64}`;
};


module.exports = {
    getBarcodeFromBase64
}
